import { styled } from '@linaria/react';
import { primitives, radius, semantic, space, textStyle } from '../../theme/tokens';
import { ContentParser } from '../../components/ContentParser';
import { EntityImage } from '../../components/EntityImage';

const bodyLg = textStyle.body.lg.regular;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const ImageSlot = styled.div`
  position: relative;
  display: flex;
  justify-content: flex-end;
  padding: ${space['space-600']};
`;

export const Image = styled(EntityImage)`
  display: block;
  width: 100%;
  aspect-ratio: 800 / 450;
  object-fit: cover;
  border-radius: ${radius('image', 'radius-md')};
`;

export const CloseButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  height: ${primitives.size['size-1200']};
  padding: 0 ${space['space-500']};
  border: none;
  border-radius: ${radius('button', 'radius-full')};
  background: ${semantic.bg.canvas};
  color: ${semantic.text.primary};
  cursor: pointer;

  [data-has-image='true'] > & {
    position: absolute;
    top: calc(${space['space-600']} + ${space['space-600']});
    right: calc(${space['space-600']} + ${space['space-600']});
    z-index: 1;
  }
`;

export const CloseIconFrame = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${primitives.size['size-600']};
  height: ${primitives.size['size-600']};
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${space['space-500']};
  padding: ${space['space-400']} ${space['space-1200']};
  text-align: center;

  [data-has-cta='false'] > & {
    padding-bottom: ${space['space-1200']};
  }
`;

export const Heading = styled.h2`
  margin: 0;
  font-family: ${textStyle.display['size-md'].fontFamily};
  font-size: ${textStyle.display['size-md'].fontSize};
  font-weight: ${textStyle.display['size-md'].fontWeight};
  line-height: ${textStyle.display['size-md'].lineHeight};
  letter-spacing: ${textStyle.display['size-md'].letterSpacing};
  color: ${semantic.text.primary};
`;

export const ValidFor = styled.p`
  margin: 0;
  font-family: ${bodyLg.fontFamily};
  font-size: ${bodyLg.fontSize};
  font-weight: ${bodyLg.fontWeight};
  line-height: ${bodyLg.lineHeight};
  letter-spacing: ${bodyLg.letterSpacing};
  color: ${semantic.text.primary};
`;

export const Body = styled(ContentParser)`
  && {
    font-family: ${bodyLg.fontFamily};
    font-size: ${bodyLg.fontSize};
    font-weight: ${bodyLg.fontWeight};
    line-height: ${bodyLg.lineHeight};
    letter-spacing: ${bodyLg.letterSpacing};
    color: ${semantic.text.secondary};
  }

  && p {
    margin: 0 0 ${space['space-200']};

    &:last-child {
      margin-bottom: 0;
    }
  }
`;

export const ActionBar = styled.div`
  padding: ${space['space-600']} ${space['space-1000']};
`;
